"use strict";
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * BROWSER POLYFILLS
 */
// IE9, IE10 and IE11 requires all of the following polyfills.
require("core-js/es6/symbol");
require("core-js/es6/object");
require("core-js/es6/function");
require("core-js/es6/parse-int");
require("core-js/es6/parse-float");
require("core-js/es6/number");
require("core-js/es6/math");
require("core-js/es6/string");
require("core-js/es6/date");
require("core-js/es6/array");
require("core-js/es6/regexp");
require("core-js/es6/map");
require("core-js/es6/weak-map");
require("core-js/es6/set");
// IE10 and IE11 requires the following for NgClass support on SVG elements
// import 'classlist.js';  // Run `npm install --save classlist.js`.
// IE10 and IE11 requires the following for the Reflect API.
// import 'core-js/es6/reflect';
// Evergreen browsers require these.
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
require("core-js/es7/reflect");
// Required to support Web Animations `@angular/platform-browser/animations`.
// Needed for: All but Chrome, Firefox and Opera. http://caniuse.com/#feat=web-animation
// import 'web-animations-js';  // Run `npm install --save web-animations-js`.
// Zone JS is required by Angular itself.
require('zone.js/dist/zone');
require('zone.js/dist/long-stack-trace-zone');
/*
 * APPLICATION IMPORTS
 */
// Date, currency, decimal and percent pipes.
// Needed for: All but Chrome, Firefox, Edge, IE11 and Safari 10
// import 'intl';  // Run `npm install --save intl`.
/*
 * Need to import at least one locale-data with intl.
 */
// import 'intl/locale-data/jsonp/en';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9seWZpbGxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicG9seWZpbGxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7Ozs7Ozs7Ozs7R0FjRzs7QUFFSDs7R0FFRztBQUNILDhEQUE4RDtBQUM5RCw4QkFBNEI7QUFDNUIsOEJBQTRCO0FBQzVCLGdDQUE4QjtBQUM5QixpQ0FBK0I7QUFDL0IsbUNBQWlDO0FBQ2pDLDhCQUE0QjtBQUM1Qiw0QkFBMEI7QUFDMUIsOEJBQTRCO0FBQzVCLDRCQUEwQjtBQUMxQiw2QkFBMkI7QUFDM0IsOEJBQTRCO0FBQzVCLDJCQUF5QjtBQUN6QixnQ0FBOEI7QUFDOUIsMkJBQXlCO0FBRXpCLDJFQUEyRTtBQUMzRSxvRUFBb0U7QUFFcEUsNERBQTREO0FBQzVELGdDQUFnQztBQUdoQyxvQ0FBb0M7QUFDcEMsa0dBQWtHO0FBQ2xHLCtCQUE2QjtBQUc3Qiw2RUFBNkU7QUFDN0Usd0ZBQXdGO0FBQ3hGLDhFQUE4RTtBQUc5RSx5Q0FBeUM7QUFDekMsT0FBTyxDQUFDLG1CQUFtQixDQUFDLENBQUM7QUFDN0IsT0FBTyxDQUFDLG9DQUFvQyxDQUFDLENBQUM7QUFHOUM7O0dBRUc7QUFFSCw2Q0FBNkM7QUFDN0MsZ0VBQWdFO0FBQ2hFLG9EQUFvRDtBQUVwRDs7R0FFRztBQUNILHNDQUFzQyJ9


//////////////////
// WEBPACK FOOTER
// ./src/polyfills.ts
// module id = 1214
// module chunks = 1